(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'emotion', '../svg/PeachjarLogoDark', '../svg/PeachjarLogoLight'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('emotion'), require('../svg/PeachjarLogoDark'), require('../svg/PeachjarLogoLight'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.emotion, global.PeachjarLogoDark, global.PeachjarLogoLight);
    global.Brandbar = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _emotion, _PeachjarLogoDark, _PeachjarLogoLight) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var React = _interopRequireWildcard(_react);

  var _PeachjarLogoDark2 = _interopRequireDefault(_PeachjarLogoDark);

  var _PeachjarLogoLight2 = _interopRequireDefault(_PeachjarLogoLight);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n    min-height: ', ';\n    height: ', ';\n    max-height: ', ';\n    padding: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);\n    background: white;\n  '], ['\n    min-height: ', ';\n    height: ', ';\n    max-height: ', ';\n    padding: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);\n    background: white;\n  ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    background: #47506b; // Todo: Import this color\n  '], ['\n    background: #47506b; // Todo: Import this color\n  ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n    margin-left: 1rem;\n  '], ['\n    margin-left: 1rem;\n  ']),
      _templateObject4 = (0, _taggedTemplateLiteralLoose3.default)(['\n    flex: 1 1 auto;\n    display: flex;\n    align-self: stretch;\n  '], ['\n    flex: 1 1 auto;\n    display: flex;\n    align-self: stretch;\n  ']);

  var BRANDBAR_HEIGHT = '56px';

  var Brandbar = function Brandbar(_ref) {
    var children = _ref.children,
        className = _ref.className,
        dark = _ref.dark,
        logoURI = _ref.logoURI;

    var PeachjarLogo = dark ? _PeachjarLogoLight2.default : _PeachjarLogoDark2.default;

    return React.createElement(
      'div',
      {
        className: (0, _emotion.cx)(classNames.brandbar, dark && classNames.dark, className)
      },
      React.createElement(
        'div',
        { className: classNames.logo },
        React.createElement(
          'a',
          { href: logoURI, 'data-testid': 'click-peachjar-logo' },
          React.createElement(PeachjarLogo, { width: '103px', height: '33px' })
        )
      ),
      React.createElement(
        'div',
        { className: classNames.flexGrow },
        children
      )
    );
  };

  Brandbar.defaultProps = {
    dark: false,
    className: '',
    children: null,
    logoURI: ''
  };

  var classNames = {
    brandbar: (0, _emotion.css)(_templateObject, BRANDBAR_HEIGHT, BRANDBAR_HEIGHT, BRANDBAR_HEIGHT),
    dark: (0, _emotion.css)(_templateObject2),
    logo: (0, _emotion.css)(_templateObject3),
    flexGrow: (0, _emotion.css)(_templateObject4)
  };

  exports.default = Brandbar;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/Brandbar.js
// module id = 2028
// module chunks = 1